import { render, staticRenderFns } from "./BuyRecord.vue?vue&type=template&id=2af75052&scoped=true&"
import script from "./BuyRecord.vue?vue&type=script&lang=js&"
export * from "./BuyRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af75052",
  null
  
)

export default component.exports